module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_phone2.7ba57.png";